exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".RoundButtons-module__button___1HzfZ{height:40px;width:40px;background-color:#bdccd4;color:#fff;border-radius:999px;display:flex;justify-content:center;align-items:center;font-size:16px;cursor:pointer;transition:.2s}.RoundButtons-module__button___1HzfZ.RoundButtons-module__audio___3OSvO{background:#1368e5}.RoundButtons-module__button___1HzfZ.RoundButtons-module__collapsed___K7mDn{background-color:#1368e5}", ""]);

// exports
exports.locals = {
	"button": "RoundButtons-module__button___1HzfZ",
	"audio": "RoundButtons-module__audio___3OSvO",
	"collapsed": "RoundButtons-module__collapsed___K7mDn"
};